import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';
import { SortDirection } from '../../../../utils/constants';

export const filterFields = {
  OrderRequestID: 'OrderRequestID',
  ClientID: 'ClientID',
  SupplyTypeIDs: 'SupplyTypeIDs',
  OrderName: 'OrderName',
  OrderRequestedBy: 'OrderRequestedBy',
  StatusID: 'StatusID',
  DueDateFrom: 'DueDateFrom',
  DueDateTo: 'DueDateTo',
  IsTemplate: 'IsTemplate',
  IsRecurring: 'IsRecurring',
  RushOrder: 'RushOrder'
};
const initialFilterState = {
  OrderRequestID: '',
  ClientID: '',
  SupplyTypeIDs: [],
  OrderName: '',
  OrderRequestedBy: '',
  StatusID: '',
  DueDateFrom: null,
  DueDateTo: null,
  Flags: 0,
  IsRecurring: false,
  RushOrder: false
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'CreatedOn',
  sortDirection: SortDirection.Desc,
};
export const orderRequestSearchsliceName = 'orderRequestSearch';
const orderRequestSlice = createSearchPageSlice({
  sliceName: orderRequestSearchsliceName,
  filterFields,
  initialFilterState,
  initialPageState
});
export const orderRequestActions = orderRequestSlice.actions;
export default orderRequestSlice.reducer;
